import { WidgetContainer } from "app/components/React/WidgetContainer/WidgetContainer";

import { HighLevelMetricsProvider } from "./context";
import { HighLevelMetrics } from "./HighLevelMetrics";

export const HighLevelMetricsOvertime = () => {
    return (
        <WidgetContainer
            hideHeader
            minHeight={440}
            automationId="industry-analysis-overview-high-level-metrics-overtime-widget"
        >
            <HighLevelMetricsProvider>
                <HighLevelMetrics />
            </HighLevelMetricsProvider>
        </WidgetContainer>
    );
};
